import script from "./ChurchVillageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChurchVillageModal.vue?vue&type=script&setup=true&lang=js"

import "./ChurchVillageModal.vue?vue&type=style&index=0&id=080f2ecc&lang=scss"

const __exports__ = script;

export default __exports__